























































import Vue from "vue";
import { ElementColors } from "@/common/theme/ElementColors";

export default Vue.extend({
  name: "PPOrderItem",
  props: {
    item: { type: Object, required: true },
    loading: { type: Boolean, required: true },
  },
  data() {
    return {
      Colors: ElementColors,
    };
  },
  computed: {
    color(): string {
      return this.item.done ? "grey lighten-5" : "";
    },
    doneBtnText(): string {
      return !this.item.done
        ? this.$t("modules.packing-portal.common.done").toString()
        : this.$t("modules.packing-portal.common.edit").toString();
    },
    downDisabled(): boolean {
      return this.item.done || this.item.collectedQuantity < 1 || this.loading;
    },
    upDisabled(): boolean {
      return this.item.done || this.item.collectedQuantity >= this.item.expectedQuantity || this.loading;
    },
  },
  beforeMount() {
    if (!this.item.collectedQuantity) {
      this.item.collectedQuantity = 0;
    }
  },
  methods: {
    decrementQuantity(): void {
      if (this.item.collectedQuantity > 0) {
        this.item.collectedQuantity--;
      }
    },
    incrementQuantity(): void {
      if (this.item.collectedQuantity < this.item.expectedQuantity) {
        this.item.collectedQuantity++;
      }
    },
    done(): void {
      this.$emit("done", this.item);
    },
  },
});
